/* eslint-disable react/prop-types */
// @ts-nocheck
import React, { useEffect, useContext, useState } from 'react';
import { connect } from 'react-redux';
import { ServiceContext } from 'contexts/service';
import { Container, Grid } from '@material-ui/core';
import NoResults from 'global/modules/NoResults';
import { sendDocumentationEmail } from 'store/actions/sales';
import { fetchProcessesBySteps, processSearch, clearResponses } from 'store/actions/processes';
import { STEP_ANALYSIS } from 'constants/process';
import { FULFILLED } from 'constants/session';
import { LoadingComponent } from 'global/modules/Loading';
import {
  array, string, oneOfType, number, func,
} from 'prop-types';
import { DEFAULT } from 'constants/common';
import Row from './Row';
import BlockRow from './BlockRow';
import Header from './Header';
import { useStyles } from '../style';
import Dialogs from './modules/Dialogs';
import Menus from './modules/Menus';
import HeaderColumn from './HeaderColumn';

function Analise({
  analysisReq,
  status,
  update,
  setUpdate,
  allProcessesReq,
  ...props
}) {
  const classes = useStyles();
  const serviceContext = useContext(ServiceContext);
  const { currentClient, currentProcess } = serviceContext;
  const [requesting, setRequesting] = useState(false);
  const [analysis, setAnalysis] = useState([...analysisReq]);
  const [allProcesses, setAllProcesses] = useState([...allProcessesReq]);

  useEffect(() => {
    if (status === FULFILLED && requesting) {
      setRequesting(false);
    }
    setAnalysis([...analysisReq]);
    setAllProcesses([...allProcessesReq]);
  }, [status, allProcessesReq, analysisReq, requesting]);

  useEffect(() => {
    if (!requesting) {
      setRequesting(true);
      props.fetchProcessesBySteps([STEP_ANALYSIS]);
      serviceContext.setSearchValue('');
      serviceContext.setSortItems(false);
    }
    // eslint-disable-next-line
  }, [update]);

  const blocked = analysis && analysis.length > 0
    ? analysis.filter((a) => a.blocked)
    : [];
  const allBlocked = allProcesses && allProcesses.length > 0
    ? allProcesses.filter((a) => a.blocked)
    : [];
  const listed = analysis && analysis.length > 0
    ? analysis.filter((a) => !a.blocked)
    : [];
  const allListed = allProcesses && allProcesses.length > 0
    ? allProcesses.filter((a) => !a.blocked)
    : [];

  return (
    <>
      <Header />
      <Container maxWidth="xl">
        <Menus />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <HeaderColumn filteredSize={blocked.length} responseSize={allBlocked.length} blocked />
            {status !== FULFILLED && blocked.length === 0 && (
              <LoadingComponent />
            )}
            {status === FULFILLED
              && blocked.length === 0
              ? (
                <NoResults
                  message="Nenhum processo travado encontrado"
                />
              ) : (
                <>
                  {blocked.map((process) => (
                    <BlockRow key={`process${process.id}`} item={process} />
                  ))}
                </>
              )}
          </Grid>
          <Grid item xs={6}>
            <HeaderColumn filteredSize={listed.length} responseSize={allListed.length} />
            {status !== FULFILLED && listed.length === 0 && (
              <LoadingComponent />
            )}
            {status === FULFILLED
              && listed.length === 0
              ? (
                <NoResults
                  message="Nenhum processo encontrado"
                />
              ) : (
                <>
                  {listed.map((process) => (
                    <Row key={`process${process.id}`} item={process} setUpdate={setUpdate} />
                  ))}
                </>
              )}
          </Grid>
        </Grid>
        {currentProcess !== null
          && Object.keys(currentClient).length > 0
          && (
            <Dialogs
              context={serviceContext}
              classes={classes}
              setUpdate={setUpdate}
              update={update}
            />
          )}
      </Container>
    </>
  );
}

Analise.propTypes = {
  analysisReq: array.isRequired,
  status: string,
  update: oneOfType([string, number]),
  setUpdate: func,
  allProcessesReq: array.isRequired,
};

Analise.defaultProps = {
  status: DEFAULT,
  update: '',
  setUpdate: () => { },
};

const mapToStateToProps = (state) => ({
  analysisReq: state.processes.collection,
  allProcessesReq: state.processes.allProcesses,
  status: state.processes.status,
});

const actions = {
  fetchProcessesBySteps,
  sendDocumentationEmail,
  processSearch,
  clearResponses,
};

export default connect(mapToStateToProps, actions)(Analise);
